module.exports = __webpack_public_path__ + "static/media/8_l_ruini_18.65_80.09.83a849d0.png";